import React, { Component } from 'react'
import FixedView from '../FixedView'
import IntractionActionsList from '../IntractionActionsList'
import { checkTranslation, translate } from '../../utils/useful'
import Collapsible from 'react-collapsible'
import importedIcons from '../inputs/icons'

export default class EmailFrame extends Component {
    state = {
        mail: [
            // { title: 'Yonnect', icon: '/assets/icons/email/y.circle.svg', mails: [{ mail: 'mh.mohseni98@yonnect.com' }, { mail: 'mh.mohseni177@yonnect.com' }], key: 'yonnect' },
            { title: 'Yonnect', icon: '/assets/icons/email/y.circle.svg', mails: [], key: 'yonnect' },
            { title: '3th Party', icon: '/assets/icons/email/3.circle.svg', mails: [], key: '3thparty' },
        ],
        collapses: {},
    }
    componentDidMount() {
        this.init()
    }
    componentDidUpdate(prevProps) {
        if (JSON.stringify(prevProps.modules) != JSON.stringify(this.props.modules)) {
            this.init()
        }
    }
    changeCollapse = (key) => {
        let collapses = this.state.collapses
        collapses[key] = this.state.collapses[key] == null ? true : !this.state.collapses[key]
        this.setState({ collapses })
    }
    init = () => {
        console.log('this.props', this.props)
        let mail = this.state.mail
        mail[0].mails = this.props.modules ?? []
        this.setState({ mail })
    }
    changeFrame = (item, index) => {
        // this.props.functionsHandler(null, 'changePage', [(item.key ?? item._id)])
        if (this.props.functionsHandler) {
            this.props.functionsHandler('admin', 'changePage', item._id, index)
        }
        this.framesOptionsList.hideView()
    }

    render() {
        return (
            <div>
                <button onClick={() => this.framesOptionsList.showView()} ref={el => this.framesNode = el} className='flexc mrd-2'>
                    <div className='flexcc pld-3 prd-4 py-1 br-5 dark-blur-bg' style={{ height: '27px' }}>
                        <div className='flexcc mrd-1'>
                            <img className={'flexcc' + (this.props.invert ? 'invert' : '')} width={18} src="/assets/icons/applets/database/frame-white.svg" />
                        </div>
                        <p className='font-size-14 ' style={{ color: this.props.colors?.textColor ?? '#fff' }}>{translate('Accounts')}</p>
                        {/* <p className='font-size-14 ' style={{ color: this.props.color ?? '#fff' }}>{this.props.currentFrame?.name ?? translate('appletframe.Frames')}</p> */}
                    </div>
                </button>
                <FixedView width={this.props.width} zIndex={10} ref={el => this.framesOptionsList = el} nodeRef={this.framesNode} xOffset={-12} bottomOffset={27} topOffset={0} maxWidth={260} >
                    <div className='bg-white br-10 p-1 shadow-3  ' >
                        <div className='p-1 sc-gray2' style={{ maxHeight: '350px', overflowY: 'scroll' }}>
                            <div className="mt-0">
                                <div className='pb-2' style={{ borderBottom: '1px solid #eee' }}>
                                    <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}appletframe.Pin Frames", icon: "/assets/icons/applets/database/pin-purple.svg" }} />

                                </div>

                                {Array.isArray(this.state.mail) && this.state.mail.map((prop, i) => {

                                    return (
                                        <div key={i} className="w-100 py-2 bb-gray">
                                            <button className="flexcb w-100 p-2 hover-gray br-5" onClick={() => this.changeCollapse(prop.key)}>
                                                <div className="flexc">
                                                    <p className="font-size-12 weight-500 main-c3 " style={{}}>{checkTranslation(prop.title)}</p>
                                                </div>

                                                <div className='flexc'>
                                                    {prop.addNew && (
                                                        <div className="mx-1" onClick={(e) => { e.stopPropagation(); this.handelFunction(prop.addNew) }}>
                                                            <div className='br-20' style={{ background: '#ddd' }}>
                                                                <img className={"transition flexcc "} width={18} src='/assets/icons/plus.svg' />
                                                            </div>
                                                        </div>
                                                    )}

                                                    <div className="">
                                                        <img className={"transition flexcc " + ((this.state.collapses[prop.key] == null || this.state.collapses[prop.key] == true) ? "" : "rotate-90-rev")} width={18} src='/assets/icons/arrow-down-gray.svg' />
                                                    </div>
                                                </div>
                                            </button>


                                            <Collapsible open={this.state.collapses[prop.key] == null ? true : this.state.collapses[prop.key]}>
                                                <div className='my-1'>
                                                    {Array.isArray(prop.mails) && prop.mails.map((item, index) => {
                                                        return (
                                                            <div className='w-100 my-1' key={index}>
                                                                <button onClick={() => this.changeFrame(item, index)} className='flexc w-100 p-2 hover-gray br-5 transition-all'>
                                                                    <div className='flexcc'>
                                                                        <img className="transition-all" src={item.icon ?? '/assets/icons/applets/general/play-games.png'} height={22} />
                                                                    </div>

                                                                    <div className='mld-3'>
                                                                        <p className='font-size-12 main-c3 '>{item.user}</p>
                                                                    </div>
                                                                </button>
                                                            </div>
                                                        )
                                                    })}
                                                </div>
                                            </Collapsible>
                                        </div>
                                    )
                                })}
                                <div className='pt-2' style={{ borderTop: '1px solid #eee', }}>
                                    <IntractionActionsList onClick={() => { this.props.changePage(['settings', 'newaccount']); this.framesOptionsList.hideView() }} language={this.props.language} data={{ title: "{{lang}}Add account", icon: importedIcons.addAccount }} />
                                </div>
                            </div>
                        </div>
                    </div>


                    {/* <div className='bg-white br-10 p-2 shadow-3 sc-gray2 ' style={{ maxHeight: '350px', overflowY: 'scroll' }}>
                        <div className=' mb-2'>
                            <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}appletframe.Pin Frames", icon: "/assets/icons/applets/database/pin-purple.svg" }} />
                        </div>
                        <div className='white-bg py-2 ' style={{ borderTop: '1px solid #eee', }}>
                            {this.state.mail.map((prop, index) => {
                                return (
                                    <div>
                                        <button className='flexcb p-2 w-100 hover-gray br-10' onClick={() => this.changeCollapse(prop.key)} >
                                            <div className='flexc'>
                                                <div className='d-flex mrd-2'>
                                                    <img className='flexcc' width={18} src={prop.icon} />
                                                </div>
                                                <p className='main-c3'>{prop.title}</p>
                                            </div>
                                            <button>
                                                <img width={22} className={'flexcc transition ' + (!this.state.collapses[prop.key] ? 'rotate-180' : '')} src='/assets/icons/applets/database/arrow-up-purple.svg' />
                                            </button>
                                        </button>
                                        <Collapsible open={!this.state.collapses[prop.key]} transitionTime={100}>
                                            <div className='br-10'>
                                                <IntractionActionsList onClick={() => { this.props.changePage('') }} language={this.props.language} data={{ title: prop.mail1, }} />
                                                <IntractionActionsList onClick={() => { this.props.changePage('') }} language={this.props.language} data={{ title: prop.mail2, }} />
                                            </div>
                                        </Collapsible>
                                    </div>
                                )
                            })}
                        </div>
                        <div className='pt-2' style={{ borderTop: '1px solid #eee', }}>
                            <IntractionActionsList onClick={() => { this.props.changePage('account') }} language={this.props.language} data={{ title: "{{lang}}Add account", icon: importedIcons.addAccount }} />
                        </div>
                    </div> */}
                </FixedView>
            </div>
        )
    }
}
